import React from 'react';
import PropTypes from 'prop-types';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { selectedCustomerIdAtom, userDataAtom } from '../Atoms';
import { MainDiv } from '../Theme/StyledComponents';
import CustomerComponents from '../Pages/CustomerPage/CustomerComponents';
import ChangePwd from '../Pages/Login/ChangePwd';
import NotAuthenticated from '../Pages/Login/NotAuthenticated';
import Setup2FA from '../Pages/Login/Setup2FA';
import SetupFIDO2 from '../Pages/Login/SetupFIDO2';
import {
  APP_ROUTES,
  ROUTES_PERMISSIONS,
  ROUTE_ICONS,
  ROUTES_COMPONENTS,
} from './routes';
import LeadComponents from '../Pages/LeadsManagement/Leads/Components/LeadComponents';
import keysToLowerCase from '../Helpers/keysToLowerCase';

const MainRouter = function MainRouter({
  handleChangeSection,
  setNewItems,
  removeClickedItem,
  changeSubmit,
  desktop = true,
  open = true,
  tablet = true,
  heightQuery = true,
  unreadMessagesCounter = 0,
  setUnreadMessagesCounter = () => {},
  changePwdError = null,
  recordCount = 0,
  userRoles = [],
  reloadActivityOutcomes,
  sidebarOpen = false,
  priorities = [],
}) {
  const location = useLocation().pathname;
  const currentSection = sessionStorage.getItem('currentSection');
  const customerId = useAtomValue(selectedCustomerIdAtom);
  const userData = useAtomValue(userDataAtom);

  /*   const lightRating = localStorage.getItem('lightRating')
    ? JSON.parse(localStorage.getItem('lightRating'))
    : [5];

  const othersRating = localStorage.getItem('generalRating')
    ? JSON.parse(localStorage.getItem('generalRating'))
    : [5, 4, 3, 2, 1, 0]; */

  const extensionData = keysToLowerCase(
    JSON.parse(userData?.extensionData || '{}')
  );
  return (
    <MainDiv
      open={!desktop ? open : true}
      mediaquery={desktop.toString()}
      location={location}
      customerId={customerId}
    >
      <Routes>
        {Object.keys(APP_ROUTES)
          .filter((route) =>
            userRoles?.find(({ roleId }) =>
              ROUTES_PERMISSIONS[route]?.find(
                (permission) =>
                  permission?.toUpperCase() === roleId?.toUpperCase()
              )
            )
          )
          .map((route) => {
            const Component = ROUTES_COMPONENTS[route];
            const Icon = ROUTE_ICONS[route];
            return (
              <Route
                key={APP_ROUTES[route]}
                path={APP_ROUTES[route]}
                element={
                  <Component
                    /*                defaultRating={
                      route === 'LIGHT' ? lightRating : othersRating
                    } */
                    reloadActivityOutcomes={reloadActivityOutcomes}
                    sectionName={route}
                    icon={<Icon />}
                    heightQuery={heightQuery}
                    handleChangeSection={handleChangeSection}
                    tablet={tablet}
                    userRoles={userRoles}
                    priorities={priorities}
                  />
                }
              />
            );
          })}

        <Route
          path="changePassword" /**Change password Page**/
          element={
            <ChangePwd loginError={changePwdError} onSubmit={changeSubmit} />
          }
        />
        <Route path="setup2FA" element={<Setup2FA />} />
        <Route path="setupFIDO2" element={<SetupFIDO2 />} />
        <Route path="/401" element={<NotAuthenticated noRedirect />} />
        <Route
          path="*"
          element={
            <Navigate
              to={
                APP_ROUTES[currentSection] ||
                APP_ROUTES[extensionData?.defaultPage] ||
                APP_ROUTES.PRIORITIES
              }
              replace
            />
          }
        />
      </Routes>
      <CustomerComponents
        removeClickedItemToDrawer={removeClickedItem}
        reAddNotificationToDrawer={setNewItems}
        recordCountDrawer={recordCount}
        unreadMessagesCounter={unreadMessagesCounter}
        setUnreadMessagesCounter={setUnreadMessagesCounter}
        userRoles={userRoles}
        sidebarOpen={sidebarOpen}
      />
      <LeadComponents
        currentLocation={Object.keys(APP_ROUTES).find(
          (route) => APP_ROUTES[route] === location
        )}
        removeClickedItemToDrawer={removeClickedItem}
        reAddNotificationToDrawer={setNewItems}
        recordCountDrawer={recordCount}
        unreadMessagesCounter={unreadMessagesCounter}
        setUnreadMessagesCounter={setUnreadMessagesCounter}
        sidebarOpen={sidebarOpen}
      />
    </MainDiv>
  );
};

MainRouter.propTypes = {
  desktop: PropTypes.bool,
  open: PropTypes.bool,
  tablet: PropTypes.bool,
  heightQuery: PropTypes.bool,
  handleChangeSection: PropTypes.func.isRequired,
  removeClickedItem: PropTypes.func.isRequired,
  setUnreadMessagesCounter: PropTypes.func,
  unreadMessagesCounter: PropTypes.number,
  changeSubmit: PropTypes.func.isRequired,
  changePwdError: PropTypes.object,
  setNewItems: PropTypes.func.isRequired,
  recordCount: PropTypes.number,
  userRoles: PropTypes.array,
};

export default MainRouter;
